export default () => ({
  list: [],
  metaType: {
    1: '文字列', // string
    2: 'テキストエリア', // textarea
    3: '数値', // number
    4: '日付', // date
    5: '時刻', // time
    6: '日時', // datetime
    7: 'セレクトボックス', // select
    8: 'マルチセレクト', // multiple select
    9: 'ラジオボタン', // radio
    10: 'チェックボックス' // checkbox
  }
})
